// src/components/rapportTypes/RapportTypes.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import QuillRichText from "../../components/QuillRichText";
import { useNavigate } from 'react-router-dom';
import "./RapportTypes.css";

export default function RapportTypes() {
   const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [titre, setTitre] = useState("");
  const [indication, setIndication] = useState("");
  const [resultat, setResultat] = useState("");
  const [conclusion, setConclusion] = useState("");
  const [saving, setSaving] = useState(false);

  const buildHeaders = () => {
    const token = localStorage.getItem("token");
    const tenantId = localStorage.getItem("tenant");
    return {
      Authorization: `Bearer ${token}`,
      ...(tenantId ? { "X-Tenant-Id": String(tenantId) } : {}),
    };
  };

  const load = async () => {
    const login = localStorage.getItem("login");
    if (!login) return;
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/user/${login}`,
        { headers: buildHeaders() }
      );
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Erreur chargement rapports types:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const openAdd = () => {
    setEditingId(null);
    setTitre("");
    setIndication("");
    setResultat("");
    setConclusion("");
    setShowModal(true);
  };

  const openEdit = (rt) => {
    setEditingId(rt.id);
    setTitre(rt.titre || "");
    setIndication(rt.indication || "");
    setResultat(rt.resultat || "");
    setConclusion(rt.conclusion || "");
    setShowModal(true);
  };

  const save = async () => {
    const login = localStorage.getItem("login");
    if (!login) return;
    if (!titre && !indication && !resultat && !conclusion) {
      alert("Renseignez au moins un champ.");
      return;
    }
    try {
      setSaving(true);
      if (editingId == null) {
        await axios.post(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/user/${login}`,
          { titre, indication, resultat, conclusion },
          { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
        );
      } else {
        await axios.put(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/${editingId}`,
          { titre, indication, resultat, conclusion },
          { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
        );
      }
      setShowModal(false);
      await load();
    } catch (e) {
      console.error("Erreur sauvegarde:", e);
      alert("Échec de la sauvegarde.");
    } finally {
      setSaving(false);
    }
  };

  const removeOne = async (id) => {
    if (!window.confirm("Supprimer ce rapport type ?")) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/${id}`,
        { headers: buildHeaders() }
      );
      await load();
    } catch (e) {
      console.error("Erreur suppression:", e);
      alert("Échec de la suppression.");
    }
  };

  return (
    <div className="rt-page">
      <div className="rt-header">
        <h2>📋 Mes rapports types</h2>
        <button className="btn-home" onClick={() => navigate("/accueil")}>
          <span role="img" aria-label="acceuil">🏠</span>Retour à l’accueil
        </button>
        <button className="btn btn-green" onClick={openAdd}>+ Ajouter </button>
      </div>

      <div className="table-container">
        <table className="histo-table">
          <thead>
            <tr>
              <th>Titre</th>
              <th>Indication</th>
              <th>Résultat</th>
              <th>Conclusion</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan="5">Chargement…</td></tr>
            )}
            {!loading && items.length === 0 && (
              <tr><td colSpan="5">Aucun rapport type</td></tr>
            )}
            {!loading && items.map((rt) => (
              <tr key={rt.id}>
              <td dangerouslySetInnerHTML={{ __html: rt.titre || "—" }} />
              <td dangerouslySetInnerHTML={{ __html: (rt.indication || "").slice(0, 200) }} />
              <td dangerouslySetInnerHTML={{ __html: (rt.resultat || "").slice(0, 200) }} />
              <td dangerouslySetInnerHTML={{ __html: (rt.conclusion || "").slice(0, 200) }} />
                <td className="rt-actions">
                  <button className="btn btn-blue" onClick={() => openEdit(rt)}>✏️ Éditer</button>
                  <button className="btn btn-red btn-small" onClick={() => removeOne(rt.id)}>🗑️ Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="popup-overlay">
          <div className="popup-content popup-wide">
            <h3>{editingId == null ? "Ajouter un rapport type" : "Éditer le rapport type"}</h3>

<div className="form-row">
            <label>Titre</label>
            <textarea
              className="title-input"
              value={titre}
              onChange={(e) => setTitre(e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>Indication</label>
            <textarea
              className="indication-input"
              value={indication}
              onChange={(e) => setIndication(e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>Résultat</label>
              <QuillRichText
                value={resultat}
                onChange={(content) => setResultat(content)} 
                placeholder="Décrire observations, mesures, localisations…"
              />
          </div>

          <div className="form-row">
            <label>Conclusion</label>
              <QuillRichText
  className="conclusion-input"
  value={conclusion}
  onChange={(content) => setConclusion(content)}
/>
          </div>

         

            <div className="actions">
              <button className="btn btn-green" onClick={save} disabled={saving}>
                {saving ? "Sauvegarde…" : "💾 Sauvegarder"}
              </button>
              <button className="btn btn-red" onClick={() => setShowModal(false)} disabled={saving}>
                ❌ Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
